import { ROUTE_PARAMS_TYPE } from '@/router';

export type CompanyIds = {
  // компания
  companyId?: string;
  // отдел
  partnerId?: string;
  // контракт
  contractId?: string;
  // владелец бизнес-карты
  cardOwnerId?: string;
};

export function getCompanyId({ id, type }: { id: string; type: string }): CompanyIds {
  switch (type) {
    case ROUTE_PARAMS_TYPE.company:
      return { companyId: id };

    case ROUTE_PARAMS_TYPE.contract:
    case ROUTE_PARAMS_TYPE.station:
      return { contractId: id };

    case ROUTE_PARAMS_TYPE.department:
      return { partnerId: id };
  }

  throw new Error('Invalid function call');
}
